import { useI18nStore } from '../../shared/i18n/i18nStore';

export function AuthEntryTabs({ mode, onChange }: { mode: 'login' | 'register'; onChange: () => void }) {
  const t = useI18nStore(s => s.t);
  return <div className="auth-entry-tabs" role="group" aria-label={t('accessMode')}>
    {(['register', 'login'] as const).map(value => <button key={value} type="button" aria-pressed={mode === value}
      className={`tap${mode === value ? ' is-active' : ''}`} onClick={() => { if (mode !== value) onChange(); }}>{t(value)}</button>)}
  </div>;
}

export function AuthIdentifierTabs({ mode, onChange }: { mode: 'phone' | 'email'; onChange: (mode: 'phone' | 'email') => void }) {
  const t = useI18nStore(s => s.t);
  return <div className="auth-identifier-tabs" role="group" aria-label={t('placeholderIdentifier')}>
    <button type="button" className="tap" aria-pressed={mode === 'phone'} onClick={() => onChange('phone')}>{t('registerByPhone')}</button>
    <span aria-hidden="true">/</span>
    <button type="button" className="tap" aria-pressed={mode === 'email'} onClick={() => onChange('email')}>{t('registerByEmail')}</button>
  </div>;
}
